import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { baseURL } from "../util/config";
import dayjs from "dayjs";
import { Box } from "@mui/material";

import CareTubeLogo from "../assets/images/MetubeLogo.png";

const CertificateVerificationPage = () => {
  const { id } = useParams();
  const [message, setMessage] = useState();
  const [data, setData] = useState();

  useEffect(() => {
    if (id) {
      axios
        .get(`${baseURL}certificate/check-validation/${id}`)
        .then((res) => res.data)
        .then((res) => {
          setMessage(res.message);
          setData(res.data);
        });
    }
  }, [id]);

  return (
    <div className="row">
      <div className="col-12 pt-5 mx-auto text-center">
        <img src={CareTubeLogo} alt="CareTube Logo" style={{ height: 100 }} />
      </div>

      <div
        className="fs-4 p-5 fw-medium text-center"
        style={{ fontFamily: "monospace" }}
      >
        {message}
      </div>

      {data ? (
        <Box
          className="col-lg-6 mx-auto px-4 px-sm-5"
          style={{ width: 600 }}
          sx={{ fontSize: { xs: "16px", sm: "16px", md: "22px" } }}
        >
          <table>
            <tr>
              <td colSpan={2} align="center" className="mb-2">
                <img className="mb-2" src={data?.providedBy?.logo} alt={data?.providedBy?.name} height={100} />
              </td>
            </tr>
            <tr className="border-bottom mb-2">
              <td style={{ width: 220, verticalAlign: "top", fontFamily: "monospace" }}>Provided By : </td>
              <td style={{ width: 500 }}>{data?.providedBy?.name}</td>
            </tr>
            <tr className="border-bottom">
              <td style={{ width: 220, verticalAlign: "top", fontFamily: "monospace" }}>Received By : </td>
              <td style={{ width: 500 }}>{data?.receivedBy}</td>
            </tr>
            <tr className="border-bottom">
              <td style={{ width: 220, verticalAlign: "top", fontFamily: "monospace" }}>Received In : </td>
              <td>{data?.receivedIn}</td>
            </tr>
            <tr className="border-bottom">
              <td style={{ width: 220, verticalAlign: "top", fontFamily: "monospace" }}>Completed On : </td>
              <td>{dayjs(data?.dateOfCompletion).format("DD MMM YYYY")}</td>
            </tr>
            <tr className="border-bottom">
              <td style={{ width: 220, verticalAlign: "top", fontFamily: "monospace" }}>Received At : </td>
              <td>{dayjs(data?.receivedAt).format("DD MMM YYYY")}</td>
            </tr>
            <tr className="border-bottom">
              <td style={{ width: 220, verticalAlign: "top", fontFamily: "monospace" }}>Signed By : </td>
              <td>{data.signedBy.join(", ")}</td>
            </tr>
          </table>
        </Box>
      ) : null}
    </div>
  );
};

export default CertificateVerificationPage;
